export default __webpack_public_path__ + "static/media/home_elwa_icon_as_SM.82b19018.svg";